import type { Content } from "@/app/queries";
import { AsideHead, readiness } from "./shared";

/** «Готовность шага»: 5 правил A1 от локального черновика; неполная — рамка warn. */
export function ReadinessCard({ content }: { content: Content }) {
  const r = readiness(content);
  const full = r.ready === r.total;
  return (
    <section className="rounded-md bg-card p-3.5" style={{ border: `1px solid ${full ? "var(--bd)" : "var(--warn)"}` }} data-testid="readiness">
      <AsideHead
        title="готовность шага"
        right={
          <span className="font-mono text-[11.5px]" style={{ color: full ? "var(--ok)" : "var(--warn)" }} data-testid="readiness-frac">
            {r.ready} / {r.total}
          </span>
        }
      />
      <ul className="m-0 flex list-none flex-col gap-[9px] p-0">
        {r.rules.map((rule) => (
          <li key={rule.text} className="grid grid-cols-[16px_minmax(0,1fr)] items-start gap-2.5">
            <span className="font-mono text-[11.5px]" style={{ color: rule.ok ? "var(--ok)" : "var(--warn)" }} aria-label={rule.ok ? "выполнено" : "не выполнено"}>
              {rule.ok ? "✓" : "○"}
            </span>
            <span className={`text-[12.5px] leading-[1.45] text-pretty ${rule.ok ? "text-mut" : "text-ink2"}`}>{rule.text}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
